import type { OralExamAggregateTimeSlotStateResponse } from '@/common/api/models/oralExamAggregateTimeSlotStateResponse';

export function unwrapOralExamCohortState(data: unknown): OralExamAggregateTimeSlotStateResponse | null {
  if (!data || typeof data !== 'object') return null;
  const layer = data as { data?: { data?: OralExamAggregateTimeSlotStateResponse } };
  return layer.data?.data ?? null;
}
